import React, { useRef } from 'react'
import Form from './form'

export default function (props) {
    const rawData = useRef({})

    return <Form rawData={rawData.current} {...props} />
}
